// PR-31: 3-tab bottom nav.
//
// Chat (was Capture in PR-26) is the default landing tab — capture is now
// just "send a message in chat", so the dedicated Capture tab was retired.
// Glyphs are unicode for bundle-size reasons; they pick up `currentColor`
// from the active/inactive tab state.

import type { MobileTab } from './MobileShell'

interface MobileBottomNavProps {
  active: MobileTab
  onChange: (tab: MobileTab) => void
}

const TABS: { id: MobileTab; label: string; glyph: string }[] = [
  { id: 'chat', label: 'Chat', glyph: '✦' },
  { id: 'cards', label: 'Cards', glyph: '▤' },
  { id: 'gaps', label: 'Gaps', glyph: '◌' },
]

export function MobileBottomNav({ active, onChange }: MobileBottomNavProps) {
  return (
    <nav className="mobile-bottomnav" aria-label="Primary">
      {TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          className="mobile-bottomnav__tab"
          aria-current={active === t.id}
          onClick={() => onChange(t.id)}
        >
          <span className="mobile-bottomnav__glyph" aria-hidden>
            {t.glyph}
          </span>
          <span className="mobile-bottomnav__label">{t.label}</span>
        </button>
      ))}
    </nav>
  )
}
